
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindTrue5 as ObiWindTrue5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-true-5.js';
 
 
 

 
 export const ObiWindTrue5 = createComponent({
   react: React,
   tagName: 'obi-wind-true-5',
   elementClass: ObiWindTrue5Element,
   events: {
     
   }
  });
 
 